import { render, staticRenderFns } from "./ResponsiveCheckBox.vue?vue&type=template&id=520c813c"
import script from "./ResponsiveCheckBox.vue?vue&type=script&lang=js"
export * from "./ResponsiveCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports